import { render } from "./AnalyticsPaginator.vue?vue&type=template&id=71a3a65f"
import script from "./AnalyticsPaginator.vue?vue&type=script&lang=js"
export * from "./AnalyticsPaginator.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__